<div class="w-full py-4 flex justify-between">
  <div 
  [ngClass]="!onWhiteBg?'text-white':'text-primary-600'"
  class="flex items-center gap-2 md:gap-5">    
    <button appRipple 
    routerLink="/"
    class="rounded-full px-4 py-1 border border-transparent hover:border-white transition-all duration-300 ease-in-out">Home</button>
    <button routerLink="/auth/join-meeting" appRipple class="rounded-full px-4 py-1 border border-transparent hover:border-white transition-all duration-300 ease-in-out">Start Meeting</button>
    <button appRipple routerLink="/auth/join-meeting" class="rounded-full px-4 py-1 border border-transparent hover:border-white transition-all duration-300 ease-in-out">Join Meeting</button>
  </div>

  <div>
    <button [matMenuTriggerFor]="menuLang"
            mat-raised-button
            class="px-3  gap-1 !bg-gray-100  border flex justify-center !shadow-sm !rounded-full items-center  cursor-pointer">
      <!-- <span class="px-1"> {{ 'Language' |concat|translate }}</span> -->
      <mat-icon>translate</mat-icon>
    </button>

    <mat-menu #menuLang="matMenu">
      <mat-list>
        <mat-list-item (click)="changeLanguage('sw')" class="border-b hover:bg-gray-50 !cursor-pointer">
          <span>Kiswahili</span>
        </mat-list-item>
        <mat-list-item (click)="changeLanguage('en')" class="hover:bg-gray-50 !cursor-pointer">
          <span>English</span>
        </mat-list-item>
    </mat-list>
    </mat-menu>
  </div>
</div>
